import { Link } from '@tanstack/react-router'
import { Home } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLang } from '@/hooks/useLang'

interface BreadcrumbItem {
  label: string
  to?: string
  params?: Record<string, string>
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  const { t } = useTranslation('common')
  const lang = useLang()

  return (
    <section className="pt-8 px-4">
      <div className="container mx-auto max-w-6xl">
        <nav className="flex items-center gap-3 text-sm text-muted-foreground">
          {/* Home link - always first */}
          <Link
            to="/$lang"
            params={{ lang }}
            className="hover:text-foreground transition-colors flex items-center gap-1"
          >
            <Home className="w-4 h-4" />
            {t('navigation.home')}
          </Link>

          {/* Separator and remaining items */}
          {items.map((item, index) => (
            <span key={index} className="flex items-center gap-3">
              <span>/</span>
              {item.to ? (
                <Link
                  to={item.to}
                  params={item.params || { lang }}
                  className="hover:text-foreground transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span>{item.label}</span>
              )}
            </span>
          ))}
        </nav>
      </div>
    </section>
  )
}
